import { formatDateRender, validDate } from 'helpers';
import styles from '../timeline.module.css';

export const getPostCreatedByString = (name, posted) => {
	const formattedDate = validDate(posted) && formatDateRender(posted, 'MMDDYY');
	switch (true) {
		case Boolean(name && formattedDate):
			return `${name} posted on ${formattedDate}`;
		case Boolean(!name && formattedDate):
			return `Posted on ${formattedDate}`;
		case Boolean(name && !formattedDate):
			return `Posted by ${name}`;
		default:
			return null;
	}
};

export default function PostCreatedBy({ createdBy: { name } = {}, posted }) {
	return (
		<div className={styles.postCreatedByRoot}>
			{getPostCreatedByString(name, posted)}
		</div>
	);
}
